// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"Checkbox_checkboxLabel__DTLdW","checkboxInput":"Checkbox_checkboxInput__u0Jzj"};